// Import scss so webpack will bundle it and export with ExtractTextPlugin
import 'core-js/fn/array/from';

import '../scss/global.scss';

import './modules/share';
import './modules/heroSlider';
import './modules/cardSlider';
import './modules/projectCategorySelector';
import './modules/slideshow';
import './modules/leadershipTabs';
import './modules/serviceModel';
import './modules/navDropdowns';
import './modules/navbar';
import './modules/navbarDropdowns';
import './modules/gallery';
import './modules/fixedHeader';



// WEBPACK FOOTER //
// ./resources/assets/js/main.js